export default __webpack_public_path__ + "static/media/mymoneysense-view-dashboard-mobile.8544c9df.svg";